<body id="page-top">
  <div id="wrapper">
    <div id="content-wrapper" class="d-flex flex-column">
      <div id="content">
        <div class="container-fluid px-4">
          <p class=""></p>
          <div class="card shadow my-4">
            <div class="card-header py-3 d-flex align-items-center justify-content-end">

              <!-- <h4 class="m-0 font-weight-bold text-primary">Bulk Creation</h4> -->
              <div class="">
                <button class="btn mx-3 btn-primary" (click)="export()">Export XLSX</button>
                <input class="btn btn-primary mx-3 inputfile" type="file" (change)="onFileChange($event)"
                  multiple="false" />
              </div>
            </div>

            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                  <!-- <thead>
                    <tr>
                      <th>Username</th>
                      <th>Register Number</th>
                      <th>Student Name</th>
                      <th>Department</th>
                      <th>Classroom</th>
                      <th>Options</th>
                    </tr>
                  </thead> -->


                  <!-- Start of DataTable -->
                  <tbody *ngIf="data.length == 1 && data[1]">
                    <tr style="text-align: center;font-size: 1em;font-weight: 600;color: brown;">
                      Import the excel file
                    </tr>
                  </tbody>
                  <tbody>
                    <tr *ngFor="let row of data">
                      <td *ngFor="let val of row">
                        {{val}}
                      </td>
                    </tr>
                  </tbody>
                  <!-- End of DataTable -->


                </table>
              </div>
            </div>
            <div class="card-footer d-flex justify-content-between">
              <div class="form-group" style="width: 40%;">
                <ng-select [items]="Classrooms" bindLabel="classroom_name" autofocus bindValue="classroom_id"
                  [(ngModel)]="Factor.classroom" name="factor" placeholder="Select Classrooms">
                </ng-select>
              </div>
              <button class=" btn btn-primary text-center" style="width: 30%;" (click)="validate_sheet()"
                *ngIf="!isLoading">Start
                creating</button>
              <button class=" btn btn-primary text-center" style="width: 30%;" [disabled]="isLoading"
                *ngIf="isLoading">Creating ... </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

</body>
